import classNames from "classnames";

export function FrostedGlassContainer({className, ...props}: {className?: string, children?: any}) {
  return (
    <div className={classNames("_frosted_glass rounded-md", className ?? "")}>
      {props.children}
    </div>
  )
}